var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.41699 13.5833L6.70949 12.2908L4.34449 9.91667L13.667 9.91667L13.667 8.08333L4.34449 8.08333L6.70949 5.71833L5.41699 4.41667L0.833657 9L5.41699 13.5833ZM17.3337 15.4167L10.0003 15.4167L10.0003 17.25L17.3337 17.25C18.342 17.25 19.167 16.425 19.167 15.4167L19.167 2.58333C19.167 1.575 18.342 0.750002 17.3337 0.750002L10.0003 0.750001L10.0003 2.58333L17.3337 2.58333L17.3337 15.4167Z",
    fill: "#EB4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOut);
export default __webpack_public_path__ + "static/media/sign_out.50ead1d24f269dcaa69f3d147b8ae0a4.svg";
export { ForwardRef as ReactComponent };